<template>
  <welcome v-if="!billingEnabled"/>
  <st-side-page class="billing-main-page" v-else>
    <portal to="page-name">Faturamento</portal>
    <template slot="side">
      <ul class="menu">
        <li class="menu-item" v-for="menu in availableMenus" :key="menu.path">
          <router-link :to="menu.path">{{ menu.label }}</router-link>
          <fa-icon :icon="['fal', 'chevron-right']"/>
        </li>
      </ul>
    </template>
    <router-view/>
  </st-side-page>
</template>

<script>
import { mapState } from 'vuex';
import {
  LIST_ACCOUNTS,
  LIST_BILLINGS,
  LIST_BILLING_TRANSFERS,
  REPORT_BILLING_RESULTS,
} from '@/data/actions/modules/financial';
import { UPDATE_BRANCH } from '@/data/actions/modules/general';
import { isEnabled as isInsuranceBillingEnabled } from '@/app/billing/guide/service';
import Welcome from './Welcome.vue';

export default {
  components: {
    Welcome,
  },
  data() {
    return {
      menus: [
        {
          path: '/financial/billing-dashboard',
          label: 'Dashboard',
          permission: LIST_BILLINGS,
          requiresBilling: true,
        },
        {
          path: '/financial/billing-accounts',
          label: 'Guias',
          permission: LIST_ACCOUNTS,
          requiresBilling: true,
        },
        {
          path: '/financial/billing-batches',
          label: 'Lotes',
          permission: LIST_BILLINGS,
          requiresBilling: true,
        },
        {
          path: '/financial/billing-glosses',
          label: 'Glosas e recursos',
          permission: LIST_BILLINGS,
          requiresBilling: true,
        },
        {
          path: '/financial/billing-transfer',
          label: 'Repasses',
          permission: LIST_BILLING_TRANSFERS,
          requiresBilling: true,
        },
        {
          path: '/financial/billing-reports',
          label: 'Relatórios',
          permission: REPORT_BILLING_RESULTS,
          requiresBilling: true,
        },
        {
          path: '/financial/billing-batches/settings',
          label: 'Configuração',
          permission: UPDATE_BRANCH,
          requiresBilling: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    billingEnabled() {
      return isInsuranceBillingEnabled(this.user);
    },
    availableMenus() {
      return this.menus.filter(menu => (
        (!menu.requiresBilling || this.billingEnabled) && this.$can(menu.permission)
      ));
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.billing-main-page {
  &.side-page {
    .side-page-side {
      flex: 0 0 11rem;
    }
  }
  .menu {
    .router-link-exact-active {
      color: $primary-color;
      & + svg {
        color: $primary-color;
      }
    }
  }
}
</style>
